<svg
  class={$$restProps.class}
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  ><path
    d="M24 12.07a12 12 0 10-13.88 11.86v-8.39H7.08v-3.47h3.05V9.43c0-3 1.79-4.67 4.53-4.67 1.31 0 2.68.24 2.68.24v2.95h-1.51c-1.5 0-1.96.92-1.96 1.87v2.25h3.33l-.53 3.47h-2.8v8.39A12 12 0 0024 12.07z"
  /></svg
>
